import { render, staticRenderFns } from "./GlobalHome.vue?vue&type=template&id=dc78bc3c&scoped=true"
import script from "./GlobalHome.vue?vue&type=script&setup=true&lang=ts"
export * from "./GlobalHome.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./GlobalHome.vue?vue&type=style&index=0&id=dc78bc3c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc78bc3c",
  null
  
)

export default component.exports